import React from 'react';

import './style.scss';

export default function BotaoArredondado({ className = '', onClick, value, ...rest }) {

    return (
        <button className={`botao-arredondado ${className}`} onClick={onClick}>
            <div className="text">{value}</div>
        </button>
    );
}